import daily from "./../assets/daily.png";
import monthly from "./../assets/monthly.png";
import weekly from "./../assets/weekly.png";

export const MODES = [
  { id: "daily", title: "Daily", desc: "Get your earnings every Day.", icon: daily },
  { id: "weekly", title: "Weekly", desc: "Get your earnings every Week.", icon: weekly },
  { id: "monthly", title: "Monthly", desc: "Get your earnings every Month.", icon: monthly },
];

export function toApiDate(isoDate) {
  const [y, m, d] = isoDate.split("-");
  return `${d}-${m}-${y}`;
}

export function getTomorrowISO() {
  const t = new Date();
  t.setDate(t.getDate() + 1);
  return t.toISOString().slice(0, 10);
}

export function formatDate(iso) {
  const d = new Date(iso.length === 10 ? iso + "T00:00:00" : iso);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}